import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@shared/utils/helpers';

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');

  const languages = {
    'en': 'EN',
    'fr-FR': 'FR',
    'nl-BE': 'NL',
  };

  function changeLanguage(language: string) {
    i18n.changeLanguage(language);
    setLanguage(language);

    localStorage.setItem('lang', language);
  }

  return (
    <ul className="inline-flex gap-1.5">
      {Object.entries(languages).map(([code, label]) => (
        <li>
          <button
            disabled={code === language}
            onClick={() => changeLanguage(code)}
            className={cn({
              'underline text-blue-800': code !== language,
              'text-gray-500': code === language,
            })}
          >
            {label}
          </button>
        </li>
      ))}
    </ul>
  );
}
